import React, { useState, useEffect, useRef, useContext, BaseSyntheticEvent, FocusEvent } from "react";
import { Form, Input, Select, InputNumber, TreeSelect } from "antd";
import { RuleRender } from "rc-field-form/lib/interface"
const { Option } = Select;
const defaultValue = null
const EditableContext = React.createContext<any>(defaultValue);
interface EditRow {
    index: number,
    [key: string]: any
}
interface SelectList {
    key: number,
    label: string,
    value: string,
    [key: string]: unknown
}
export interface ITreeData {
    key?: string,
    value?: string,
    title?: string,
    disabled?: boolean,
    selectable?: boolean
    children?: ITreeData[]
}
export type OptionDsType = {
    label: string,
    value: string,
}
export interface Column {
    title: string,
    dataIndex: string,
    editInd: number,
    editable?: boolean,
    width?: number,
    editType: string,
    selectList?: SelectList[],
    prefix?: string,
    suffix?: string,
    [key: string]: any
}

//tr 行信息
export interface Item {
    [key: string]: string | number | boolean | undefined | object
}

interface FindItem {
    [key: string]: string | number | boolean | undefined
}
interface EditCell {
    title: string,
    editable: boolean,
    children: any,
    dataIndex: string,
    record: FindItem,
    handleSave: Function,
    enterRow: Function,
    column: Column[],
    editList: FindItem[],
    editType: string
    prefix?: string,
    suffix?: string,
    checkAll?: boolean,
    selectList?: SelectList[],
    treeList?: ITreeData[],
    onSelectChange?: (value: string, options: OptionDsType, record: FindItem) => void,
    onTreeChange?: (value: string, label: string, extra: any) => void,
    onTreeSelect?: (value: string, node: any) => void,
    onSelectFocus?: (record: FindItem) => void
    [key: string]: any
}

enum EditType {
    select,
    inputNumber,
    input,
    treeSelect
}
const EditableRow = ({ index, ...props }: EditRow) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    enterRow,
    column,
    editList,
    editType,
    prefix,
    suffix,
    checkAll,
    selectList = [],
    treeList = [],
    onSelectChange,
    onTreeChange,
    onTreeSelect,
    onSelectFocus,
    ...restProps
}: EditCell) => {
    const [editing, setEditing] = useState(false);
    const [selectVal, setSelectVal] = useState<number>(-1)
    const inputRef: React.MutableRefObject<any> = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
        if (editType == "select") {
            setSelectVal(selectList.findIndex((item: SelectList) => item.value === record[dataIndex]))
        }
    }, [editing])

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const onKeyDown = async (event: any) => {
        let node = event.target
        let trParentNode = node.closest("tr")
        let checkRow: number = checkAll ? 1 : 0//这里查看表格是否为多选状态
        let findIndex = editList.findIndex((item: FindItem) => item.id == record.id)
        let findInd = column.findIndex((item: Column) => item.dataIndex == dataIndex)
        if (event.keyCode === 40 && findIndex !== editList.length - 1) {
            trParentNode.nextSibling.children[findInd + checkRow].children[0].click()
        }
        if (event.keyCode === 38 && findIndex !== 0) {
            trParentNode.previousSibling.children[findInd + checkRow].children[0].click()
        }
        if (event.keyCode === 9) {
            event.stopPropagation();
            event.preventDefault();
            let reducerArr = column.reduce((cur: number[], pre: Column, index: number) => {
                if (pre.editable) {
                    cur.push(index + checkRow)
                }
                return cur
            }, [])
            let subscript = reducerArr.indexOf(findInd + checkRow)
            if (subscript === reducerArr.length - 1) {
                trParentNode.children[reducerArr[0]].children[0].click()
            } else {
                trParentNode.children[reducerArr[subscript + 1]].children[0].click()
            }
        }
        if (event.keyCode === 13) {
            event.stopPropagation()
            const values = await form.validateFields();
            enterRow({ ...record, ...values })
        }
    }
    const save = async (e: BaseSyntheticEvent) => {
        e.stopPropagation()
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('数据保存失败', errInfo);
        }
    };
    const save1 = async (value: string) => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('数据保存失败', errInfo);
        }
    }
    const onFocus = (e: FocusEvent) => {
        inputRef.current.select()
    }
    const onkeydown = (e: any) => {
        if (e.keyCode === 83 && selectVal !== selectList.length - 1) {
            let filterInd = selectList.filter((item: SelectList, index: number) => index === selectVal + 1)
            let val = filterInd[0].value
            setSelectVal(selectVal + 1)
            form.setFieldsValue({ [dataIndex]: val })
        }
        if (e.keyCode === 87 && selectVal !== 0) {
            let filterInd = selectList.filter((item: SelectList, index: number) => index === selectVal - 1)
            let val = filterInd[0].value
            setSelectVal(selectVal - 1)
            form.setFieldsValue({ [dataIndex]: val })
        }
    }
    const inputTypes = (str: string, record?: FindItem, prefix?: string, suffix?: string) => {
        if (editType === EditType[0]) {
            return <Select
                onKeyDown={onKeyDown}
                onInputKeyDown={onkeydown}
                ref={inputRef}
                onChange={save1}
                onBlur={save}
                options={selectList}
                onSelect={(value: string, option) => { onSelectChange?.(value, option as OptionDsType, record as FindItem) }}
                onFocus={() => onSelectFocus?.(record as FindItem)}
            />
        } else if (editType === EditType[3]) {
            return <TreeSelect
                ref={inputRef}
                onChange={save1}
                onBlur={save}
                onKeyDown={onKeyDown}
                // disabled={props.disable}
                // allowClear={props.allowClear}
                treeData={treeList}
                // onChange={(value: string, label, extra) => onTreeChange?.(value, label as any, extra)}
                // onChange={(value: string, label, extra) =>{ return console.log(value, label)}}
                onSelect={(value: any, node: any,) => { return onTreeSelect?.(value, node) }}
            />
        } else {
            return <Input ref={inputRef}
                onFocus={onFocus}
                onBlur={save}
                prefix={prefix}
                suffix={suffix}
                onKeyDown={onKeyDown}
                autoComplete="off"
                style={{
                    margin: 0,
                }}
            />
        }

    }
    const proof: any = (editType: string) => {
        switch (editType) {
            case EditType[0]:
                return [{ required: true, message: `不能为空.` }]
            case EditType[1]:
                return [{ required: true, message: `不能为空.` }, { type: 'number', transform: (value: string) => Math.abs(Number(value)), message: `当前不是一个有效数字`, }]
            case EditType[3]:
                return [{ required: true, message: `不能为空.` }]
            default:
                return []
        }
    }
    let childNode = children;
    if (editable || (record && record.editShow)) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={proof(editType)}
            >
                {inputTypes(editType, record, prefix, suffix)}
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>
}
export {
    EditableRow,
    EditableCell
}  